import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import cn from 'classnames';
import { useDevice } from '../Device';
import styles from './Layout.module.scss';
export const Box = /*#__PURE__*/ forwardRef((_0, _1)=>{
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, { className, children, gap, gapMobile, alignItems, justifyContent, padding, width, height, wrap, style, as, testId, inline, grow } = _ref1, rest = _object_without_properties(_ref1, [
        "className",
        "children",
        "gap",
        "gapMobile",
        "alignItems",
        "justifyContent",
        "padding",
        "width",
        "height",
        "wrap",
        "style",
        "as",
        "testId",
        "inline",
        "grow"
    ]), [ref] = _rest;
    const { isMobileDevice } = useDevice();
    const Component = as || 'div';
    return /*#__PURE__*/ _jsx(Component, _object_spread_props(_object_spread({
        ref: ref,
        className: cn(inline ? styles.inlineBox : styles.box, {
            [styles.grow]: grow
        }, className),
        "data-testid": testId
    }, rest), {
        style: _object_spread({
            gap: gapMobile != null && isMobileDevice ? gapMobile : gap,
            alignItems,
            justifyContent,
            padding,
            width,
            height,
            flexWrap: wrap ? 'wrap' : 'nowrap'
        }, style),
        children: children
    }));
});
Box.displayName = 'Box';
